import React from "react";
import { useSelector } from "react-redux";

// import Loader from "../../../Loader";

const FooterBottom = () => {
  const { page } = useSelector((state) => state.data);

  // If data is not ready yet, show loader
  // if (!page || !page.data) return <Loader />;

  const footerBottom = page.data["footer-bottom"];
  const htmlContent =
    footerBottom?.siteId === 2 ? footerBottom?.htmlContent : null;

  return (
    <div className="footer-bottom">
      {htmlContent ? (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      ) : (
        ""
      )}
    </div>
  );
};

export default FooterBottom;
